module.exports = __webpack_public_path__ + "static/connection-d8e9b7af05aa7f12ec9284c54b6d1e07.svg";